export interface ICommand { }

export class CreateRegionCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.Regions.Commands.CreateRegionCommandV1, TCh.Domain.RankHR'

	Id: string
	Name: string

	constructor (id: string, name: string)
	{
		this.Id = id
		this.Name = name
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.Regions.Commands.CreateRegionCommandV1, TCh.Domain.RankHR'
	}

}

export class CreateVotingCycleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.Regions.Commands.CreateVotingCycleCommandV1, TCh.Domain.RankHR'

	Id: string
	VotingCycle: string

	constructor (id: string, votingCycle: string)
	{
		this.Id = id
		this.VotingCycle = votingCycle
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.Regions.Commands.CreateVotingCycleCommandV1, TCh.Domain.RankHR'
	}

}

export class DisableAnonymousModeCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.Regions.Commands.DisableAnonymousModeCommandV1, TCh.Domain.RankHR'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.Regions.Commands.DisableAnonymousModeCommandV1, TCh.Domain.RankHR'
	}

}

export class EnableAnonymousModeCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.Regions.Commands.EnableAnonymousModeCommandV1, TCh.Domain.RankHR'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.Regions.Commands.EnableAnonymousModeCommandV1, TCh.Domain.RankHR'
	}

}

export class RemoveVotingCycleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.Regions.Commands.RemoveVotingCycleCommandV1, TCh.Domain.RankHR'

	Id: string
	VotingCycle: string

	constructor (id: string, votingCycle: string)
	{
		this.Id = id
		this.VotingCycle = votingCycle
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.Regions.Commands.RemoveVotingCycleCommandV1, TCh.Domain.RankHR'
	}

}

export class SetCriteriaVersionCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.Regions.Commands.SetCriteriaVersionCommandV1, TCh.Domain.RankHR'

	Id: string
	CriteriaVersion: string
	VotingCycle: string

	constructor (id: string, criteriaVersion: string, votingCycle: string)
	{
		this.Id = id
		this.CriteriaVersion = criteriaVersion
		this.VotingCycle = votingCycle
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.Regions.Commands.SetCriteriaVersionCommandV1, TCh.Domain.RankHR'
	}

}

export class StartVotingCycleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.Regions.Commands.StartVotingCycleCommandV1, TCh.Domain.RankHR'

	Id: string
	VotingCycle: string

	constructor (id: string, votingCycle: string)
	{
		this.Id = id
		this.VotingCycle = votingCycle
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.Regions.Commands.StartVotingCycleCommandV1, TCh.Domain.RankHR'
	}

}

export class StopVotingCycleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.Regions.Commands.StopVotingCycleCommandV1, TCh.Domain.RankHR'

	Id: string
	VotingCycle: string

	constructor (id: string, votingCycle: string)
	{
		this.Id = id
		this.VotingCycle = votingCycle
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.Regions.Commands.StopVotingCycleCommandV1, TCh.Domain.RankHR'
	}

}

export class SwitchVotingCycleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.Regions.Commands.SwitchVotingCycleCommandV1, TCh.Domain.RankHR'

	Id: string
	VotingCycle: string

	constructor (id: string, votingCycle: string)
	{
		this.Id = id
		this.VotingCycle = votingCycle
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.Regions.Commands.SwitchVotingCycleCommandV1, TCh.Domain.RankHR'
	}

}

